import {Header} from "../components/header";
import {MainNavLinks} from "../navLinks";

export const ErrorElement = () => (
    <>
        <Header links = { MainNavLinks } />
        <div>Error loading page.</div>
    </>
)
